/* eslint-disable unicorn/filename-case */
import React, { ComponentType, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Accordion, AccordionColumn } from '../../../components/accordion/accordion'
import { rem } from '../../../utils'
import { html } from '../../../utils/htmlParser'
import { NewsFaqFragment } from '@gql'
import { Grid } from '@material-ui/core'

export type NewsFAQProps = {
  data: NewsFaqFragment[]
  twoColumn?: boolean
}

const StyledAccordionWrapper = styled(Accordion)`
  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: ${props => rem(74, props.theme)};
  }
`

const StyledAccordion = styled(Accordion)`
`

export const FAQAccordions: React.FC<PropsWithChildren<NewsFAQProps>> = ({ data, twoColumn }) => {
  const Column = twoColumn ? AccordionColumn : React.Fragment

  return (
    <StyledAccordionWrapper>
      {data.map((FAQ) => {
        return FAQ.__typename !== 'faqs_default_Entry' ? null : (
          <Column>
            <StyledAccordion panel key={FAQ.id}>
              <Accordion title>{FAQ.title}</Accordion>
              <Accordion content>{html(FAQ.faqText ?? '')}</Accordion>
            </StyledAccordion>
          </Column>
        )
      })}
    </StyledAccordionWrapper>
  )
}
